document.querySelectorAll("global-header nav ul").forEach(setupContainer);

function setupContainer(container) {
	// const observer = new IntersectionObserver((entries, observer) => {
	// 	entries.forEach(entry => {
	// 		if(entry.intersectionRatio > 0) {
	// 			console.log("Visible: ", entry);
	// 		}
	// 		else {
	// 			console.log("Invisible: ", entry);
	// 		}
	// 	});
	// });
	//
	// observer.observe(container);
}
